module.exports = __webpack_public_path__ + "static/media/ig=clone.65836c87.png";